import { Component } from '@angular/core';
import { NgClass, DatePipe } from '@angular/common';
// Services
import { SharedService } from '../../services/shared.service';
// components
import { ModalID } from '../../models/constants';
import { BoundBookEntry } from '../../models/general';

@Component({
    selector: 'app-duplicate-ttsn',
    templateUrl: './duplicate-ttsn.component.html',
    styleUrl: './duplicate-ttsn.component.scss',
    standalone: true,
    imports: [NgClass, DatePipe]
})
export class DuplicateTtsnComponent {
  form4473Id: string;
  firearm_data: BoundBookEntry[] = [];
  constructor(public sharedService: SharedService) {}
  ngOnInit(): void {
  //  setTimeout(() => { // remove after testing
      this.findFirearmData();
  //  }, 2000);
  }

  findFirearmData() {
    this.firearm_data = this.sharedService.bound_book.filter(
      (firearm) => firearm.d_form4473_id === this.form4473Id
    );
    this.firearm_data = [...this.firearm_data];
  }
  proceedClick() {
    this.sharedService.proceed_with_duplicate_ttsn$.next(true);
    this.sharedService.closeModal(ModalID.duplicate_ttsn);
  }
  closeModalClick() {
    this.sharedService.proceed_with_duplicate_ttsn$.next(false);
    this.sharedService.closeModal(ModalID.duplicate_ttsn);
  }
}
